import { type ExtensionFieldAttributes } from './generated/ExtensionFieldAttributes';
import { model } from '../modelBuilder';
import ApplicationModel, { attr } from '../ApplicationModel';

interface ExtensionField extends ExtensionFieldAttributes {}

@model
class ExtensionField extends ApplicationModel {
  // Start auto-generated
  static typename: 'ExtensionField' = 'ExtensionField';
  get typename(): 'ExtensionField' {
    return 'ExtensionField';
  }

  static internalTypename: 'ExtensionField' = 'ExtensionField';
  get internalTypename(): 'ExtensionField' {
    return 'ExtensionField';
  }

  static inputType = 'ExtensionFieldAttributes!';

  static filterType = 'ExtensionFieldsFilters!';
  static filters = {
    name: 'String',
    names: '[String!]',
    value: 'Scalar',
    key: 'String',
    query: 'String',
    extensionFieldableType: 'ExtensionFieldableTypeEnum!',
    extensionFieldableId: 'ID',
    extensionId: 'ID',
    extensionIdentifier: 'String',
  };

  static fields = {
    createdAt: attr({ readable: true }),
    extensionFieldableId: attr({ writable: true, readable: true }),
    extensionFieldableType: attr({ writable: true, readable: true }),
    id: attr({ readable: true }),
    name: attr({ writable: true, readable: true }),
    updatedAt: attr({ readable: true }),
    value: attr({ writable: true, readable: true, json: true }),
    extension: attr.belongsTo({
      writeShape: ['id'],
      readable: true,
      typename: 'Extension',
    }),
    extensionFieldable: attr.belongsTo({
      readable: true,
      typename: [
        'Account',
        'Epic',
        'Feature',
        'Iteration',
        'Project',
        'Release',
        'Requirement',
        'User',
      ],
    }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
  };
  // End auto-generated
}

export default ExtensionField;
